//@ts-nocheck

import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {showMessage} from 'app/redux/messageSlice'
import DraftOrderService from 'app/services/DraftOrderService'
import shippingMethodsService from 'app/features/orders/services/ShippingComplianceService'
import {setShippingRate, setShippingComplianceAndTax} from './draftOrderSlice'
import {mapToCreateShippingRateAndTaxInput, mapToUpdateShippingRateInput} from '../../helper'
import {compliantStatusTypes} from 'app/constant'

export const saveShippingRate = (shippingMethod: any) => async (dispatch: any) => {
  const {shipping, draftOrder} = shippingMethod
  if (draftOrder.shippingRateId) {
    dispatch(updateShippingRate({shipping, draftOrder}))
  } else {
    dispatch(createShippingRate({draftOrder, shipping}))
  }
}

export const createShippingRate = createAsyncThunk(
  'shipping/rate/create',
  async ({shipping, draftOrder}: any, {dispatch, rejectWithValue}) => {
    try {
      dispatch(setIsSubmitting(true))
      const order = mapToCreateShippingRateAndTaxInput(draftOrder, shipping)
      const shippingRate = await DraftOrderService.createShippingRate(order)
      dispatch(setShippingRate(shippingRate))
      dispatch(checkCompliance(draftOrder.id))
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({
          message: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
      return rejectWithValue(error)
    } finally {
      dispatch(setIsSubmitting(false))
    }
  }
)

export const updateShippingRate = createAsyncThunk(
  'shipping/rate/update',
  async ({shipping, draftOrder}: any, {dispatch, rejectWithValue}) => {
    try {
      dispatch(setIsSubmitting(true))
      const order = mapToUpdateShippingRateInput(draftOrder, shipping)
      await DraftOrderService.updateDraftOrder(order, draftOrder.id)
      const shippingRate = {
        ...order.shippingRate.updateById.patch,
        id: draftOrder?.shippingRateId,
      }
      dispatch(setShippingRate(shippingRate))
      dispatch(checkCompliance(draftOrder.id))
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({
          message: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
      return rejectWithValue(error)
    } finally {
      dispatch(setIsSubmitting(false))
    }
  }
)

export const checkCompliance = createAsyncThunk(
  'shipping/check-compliance',
  async (id: any, {dispatch, rejectWithValue}) => {
    try {
      dispatch(setTaxIsFetching(true))
      const result = await shippingMethodsService.getShippingComplianceAndTax(id)
      if (result.complianceStatus === compliantStatusTypes.COMPLIANT) {
        const {
          salesTax: {totalTax, crv},
        } = result
        dispatch(setShippingComplianceAndTax({totalTax,crv, isCompliant: true}))
      } else {
        dispatch(setShippingComplianceAndTax({totalTax: 0,crv:0, isCompliant: false}))
      }
      return result
    } catch (error) {
      dispatch(
        showMessage({
          message: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
      return rejectWithValue(error)
    } finally {
      dispatch(setTaxIsFetching(false))
    }
  }
)

const initialState = {
  isSubmitting: false,
  isFetching: false,
  isTaxFetching: false,
  errors: null,
  isComplianceChecked: false,
}

const shippingSlice = createSlice({
  name: 'shippingRate',
  initialState,
  reducers: {
    setIsSubmitting: (state, action) => {
      state.isSubmitting = action.payload
    },

    setIsFetching: (state, action) => {
      state.isFetching = action.payload
    },

    setTaxIsFetching: (state, action) => {
      state.isTaxFetching = action.payload
    },

    setIsComplianceChecked: (state, action) => {
      state.isComplianceChecked = action.payload
    },

    setErrors: (state, action) => {
      state.errors = action.payload
    },

    resetShippingState: () => {
      return initialState
    },
  },
  extraReducers: {
    [checkCompliance.fulfilled.toString()]: (state, action) => {
      const {complianceStatus, errors} = action.payload
      if (complianceStatus === compliantStatusTypes.COMPLIANT) {
        state.errors = null
      } else {
        state.errors = errors
      }
      state.isComplianceChecked = true
    },
  },
})

export const {
  setIsSubmitting,
  setIsFetching,
  setTaxIsFetching,
  setIsComplianceChecked,
  resetShippingState,
  setErrors,
} = shippingSlice.actions

export default shippingSlice.reducer
